import React, { useState, useEffect, useCallback } from 'react';
import { Spin, message } from 'antd'; // Ant Design components
import ArticleCardList from '../../componenents/Lists/ArticleCardList';
import { fetchApprovedArticlesService, fetchPublicArticlesService } from '../../services/ArticleService'; 
import { loginEmailService } from '../../services/AuthService'; 

import Container from '../../componenents/Container';
import CategoryCard from '../../componenents/Cards/CategoryCard';
import { useNavigate } from 'react-router-dom';

const UserArticlePage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false); 
  const navigate = useNavigate();

  // -----------------------------------------------------------------------
  // 1. AUTO-LOGIN LOGIC
  // -----------------------------------------------------------------------
  // Wrapped in useCallback to prevent unnecessary re-renders
  const checkAutoLogin = useCallback(async () => {
    const connectedEmail = localStorage.getItem('connectedInHmi');
    const hasToken = localStorage.getItem('authToken');

    // Only attempt login if we have an email from the first site but NO session token yet
    if (connectedEmail && !hasToken) {
      try {
        console.log("Attempting auto-login for:", connectedEmail);
        const response = await loginEmailService(connectedEmail);
        
        const { token, user_status, roleType } = response;
        console.log("Login Response:", { token, roletype: roleType, userstatus: user_status });

        if (user_status === 'INACTIVE') {
          message.warning('Account needs approval.');
        } else if (token) {
          // IMPORTANT: Save the token so the next check knows we are logged in
          localStorage.setItem('authToken', token);
          
          message.success('Welcome back!');
          setAuth(true); // This triggers the article refresh effect below

          // Handle Role Redirection
          if (roleType === 'ADMIN' || roleType === 'EDITOR') {
            console.log("Redirecting to admin panel...");
            navigate('/admin/home');
          }
        }
      } catch (error) {
        console.error("Auto-login failed", error);
      }
    }
  }, [navigate]);

  // -----------------------------------------------------------------------
  // 2. EVENT LISTENER EFFECT
  // -----------------------------------------------------------------------
  useEffect(() => {
    // Run once on component mount
    checkAutoLogin();

    // Listen for the 'hmi-login-ready' event dispatched from App.js
    window.addEventListener('hmi-login-ready', checkAutoLogin);

    return () => {
      // Cleanup listener on unmount
      window.removeEventListener('hmi-login-ready', checkAutoLogin);
    };
  }, [checkAutoLogin]);

  // -----------------------------------------------------------------------
  // 3. DATA FETCHING EFFECT
  // -----------------------------------------------------------------------
  useEffect(() => {
    // Determine current auth status
    const isAuth = localStorage.getItem('authToken') !== null;
    setAuth(isAuth);

    const loadArticles = async () => {
      setLoading(true);
      try {
        // Fetch specific articles based on whether user is logged in
        const fetchedArticles = isAuth 
          ? await fetchApprovedArticlesService() 
          : await fetchPublicArticlesService();
        
        setArticles(fetchedArticles);
      } catch (error) {
        console.error('Failed to load articles', error);
        message.error('Could not load articles.');
      } finally {
        setLoading(false);
      }
    };

    loadArticles();
  }, [auth]); // Re-runs whenever 'auth' state changes (e.g., after checkAutoLogin succeeds)

  return (
    <Container>
      <div style={{ minHeight: '400px' }}>
        <h1>Recent articles</h1>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Spin size="large" tip="Loading articles..." />
          </div>
        ) : (
          <ArticleCardList articles={articles} />
        )}
      </div>
      <CategoryCard />
    </Container>
  );
};

export default UserArticlePage;